import React from 'react';
/**
 * H1 heading for the Daedo PSS Systems category page.
 */
export function Heading() {
  return <h1 className="text-4xl sm:text-5xl font-black text-gray-900 uppercase tracking-tight mb-6" data-id="element-202">
      Daedo PSS Systems
    </h1>;
}